import { SVGProps } from 'react';

const ExclamationIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.1994 7.50004V9.1667M10.1994 12.5H10.2077M4.42607 15.8334H15.9727C17.2561 15.8334 18.0577 14.4442 17.4161 13.3334L11.6427 3.33337C11.0011 2.22254 9.39773 2.22254 8.75607 3.33337L2.98273 13.3334C2.34107 14.4442 3.14273 15.8334 4.42607 15.8334Z"
      strokeWidth="1.5"
      strokeLinecap="square"
      stroke="currentColor"
    />
  </svg>
);

export default ExclamationIcon;
